<template>
  <div class="modelContent">
    <div class="selectType">
      <span>{{ $t('aiModel.series') }}:</span>
      <div>
        <span
          v-for="(item, index) in seriesList"
          :key="index"
          :class="{ active: selectedSeries === item.value }"
          @click="selectedSeries = item.value"
        >
          {{ item.label }}
        </span>
      </div>
    </div>
    <div class="selectType">
      <span>{{ $t('aiModel.type') }}:</span>
      <div>
        <span
          v-for="(item, index) in typeList"
          :key="index"
          :class="{ active: selectedType === item.value }"
          @click="selectedType = item.value"
        >
          {{ item.label }}
        </span>
      </div>
    </div>
    <div class="content">
      <div class="list" v-for="(item, index) in filteredModelList" :key="index" @click="openDetail(item)">
        <img v-if="item.series === 'DeepSeek'" src="@/assets/img/model_d.png" alt="" />
        <img v-else-if="item.series === 'Qwen'" src="@/assets/img/model_q.png" alt="" />
        <img v-else-if="item.series === 'THUDM'" src="@/assets/img/model_zp.png" alt="" />
        <img v-else src="@/assets/img/model_tx.png" alt="" />
        <div class="title">{{ item.name }}</div>
        <div class="tag">{{ item.type }}</div>
        <div class="install" :class="{ not: item.status === $t('aiModel.notInstalled') }">
          {{ item.status === $t('aiModel.notInstalled') ? $t('aiModel.notInstalled') : $t('aiModel.installed') }}
        </div>
        <div class="model-info" v-if="showDetailIndex === index">
          <div class="info-item">
            <span class="label">{{ $t('aiModel.spec') }}：</span>
            <span class="value">{{ item.spec }}</span>
          </div>
          <div class="info-item">
            <span class="label">{{ $t('aiModel.textProcess') }}：</span>
            <span class="value">{{ item.textProcess }}</span>
          </div>
          <div class="info-item">
            <span class="label">{{ $t('aiModel.intro') }}：</span>
            <span class="value">{{ item.intro }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="filteredModelList.length === 0" class="nodata">
      <img src="@/assets/img/bj_zanwu@2x.png" alt="" />
      <div>
        <div class="text">{{ $t('class.noClass') }}</div>
      </div>
    </div>
    <div class="detail" v-if="showDetailModal" @click="showDetailModal = false">
      <div @click.stop>
        <div class="header">
          <div class="title">{{ selectedModel.name }}</div>
          <img class="close" src="@/assets/icons/ai_model_gb.png" alt="" @click="showDetailModal = false" />
        </div>
        <div class="tag">
          <div class="list">
            <img src="@/assets/icons/ai_model_dx.png" alt="" />
            <span>{{ $t('aiModel.spec') }}：</span>
            <span>{{ selectedModel.spec }}</span>
          </div>
          <div class="list">
            <img src="@/assets/icons/ai_model_cl.png" alt="" />
            <span>{{ $t('aiModel.textProcess') }}：</span>
            <span>{{ selectedModel.textProcess }}</span>
          </div>
          <div class="list">
            <img src="@/assets/icons/ai_model_zy.png" alt="" />
            <span>{{ $t('aiModel.type') }}：</span>
            <span>{{ selectedModel.type }}</span>
          </div>
          <div class="list">
            <img src="@/assets/icons/ai_model.png" alt="" />
            <span>{{ $t('aiModel.series') }}：</span>
            <span>{{ selectedModel.series }}</span>
          </div>
        </div>
        <div class="intro">
          <div class="title">{{ $t('aiModel.applicationIntro') }}：</div>
          <div>
            {{ selectedModel.intro }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedSeries: 'all',
      selectedType: 'all',
      showDetailIndex: -1,
      showDetailModal: false,
      selectedModel: {},
      seriesList: [
        { label: this.$t('aiModel.all'), value: 'all' },
        { label: this.$t('aiModel.deepSeek'), value: 'DeepSeek' },
        { label: this.$t('aiModel.qwen'), value: 'Qwen' },
        { label: this.$t('aiModel.zhipu'), value: 'THUDM' },
        { label: this.$t('aiModel.tencentHunyuan'), value: 'tencent' },
        // { label: '其他', value: 'BAAI' }
      ],
      typeList: [
        { label: this.$t('aiModel.all'), value: 'all' },
        { label: this.$t('aiModel.textGeneration'), value: this.$t('aiModel.textGeneration') },
        // { label: 'Rerank模型', value: 'Rerank模型' },
        { label: this.$t('aiModel.videoGeneration'), value: this.$t('aiModel.videoGeneration') }
      ],
      modelList: [
        {
          name: 'DeepSeek-R1-Distill-Qwen-7B',
          type: this.$t('aiModel.textGeneration'),
          status: this.$t('aiModel.notInstalled'),
          spec: '7B',
          textProcess: '32K',
          series: 'DeepSeek',
          intro: this.$t('aiModel.modelIntros.deepSeekR1DistillQwen7B')
        },
        {
          name: 'DeepSeek-R1-Distill-Qwen-1.5B',
          type: this.$t('aiModel.textGeneration'),
          status: this.$t('aiModel.notInstalled'),
          spec: '1.5B',
          textProcess: '32K',
          series: 'DeepSeek',
          intro: this.$t('aiModel.modelIntros.deepSeekR1DistillQwen1_5B')
        },
        {
          name: 'DeepSeek-R1-Distill-Qwen-14B',
          type: this.$t('aiModel.textGeneration'),
          status: this.$t('aiModel.notInstalled'),
          spec: '14B',
          textProcess: '32K',
          series: 'DeepSeek',
          intro: this.$t('aiModel.modelIntros.deepSeekR1DistillQwen14B')
        },
        {
          name: 'DeepSeek-R1-Distill-Qwen-32B',
          type: this.$t('aiModel.textGeneration'),
          status: this.$t('aiModel.installed'),
          spec: '32B',
          textProcess: '32K',
          series: 'DeepSeek',
          intro: this.$t('aiModel.modelIntros.deepSeekR1DistillQwen32B')
        },
        {
          name: 'Qwen2.5-7B-Instruct',
          type: this.$t('aiModel.textGeneration'),
          status: this.$t('aiModel.notInstalled'),
          spec: '7B',
          textProcess: '32K',
          series: 'Qwen',
          intro: this.$t('aiModel.modelIntros.qwen2_5_7B_Instruct')
        },
        {
          name: 'Qwen2.5-Coder-7B-Instruct',
          type: this.$t('aiModel.textGeneration'),
          status: this.$t('aiModel.notInstalled'),
          spec: '7B',
          textProcess: '32K',
          series: 'Qwen',
          intro: this.$t('aiModel.modelIntros.qwen2_5_Coder_7B_Instruct')
        },
        {
          name: 'Qwen2-7B-Instruct',
          type: this.$t('aiModel.textGeneration'),
          status: this.$t('aiModel.notInstalled'),
          spec: '7B',
          textProcess: '32K',
          series: 'Qwen',
          intro: this.$t('aiModel.modelIntros.qwen2_7B_Instruct')
        },
        {
          name: 'Qwen2-1.5B-Instruct',
          type: this.$t('aiModel.textGeneration'),
          status: this.$t('aiModel.notInstalled'),
          spec: '1.5B',
          textProcess: '32K',
          series: 'Qwen',
          intro: this.$t('aiModel.modelIntros.qwen2_1_5B_Instruct')
        },
        {
          name: 'glm-4-9b-chat',
          type: this.$t('aiModel.textGeneration'),
          status: this.$t('aiModel.notInstalled'),
          spec: '9B',
          textProcess: '128K',
          series: 'THUDM',
          intro: this.$t('aiModel.modelIntros.glm_4_9b_chat')
        },
        // {
        //   name: 'bge-reranker-v2-m3',
        //   type: 'Rerank模型',
        //   status: '未安装',
        //   spec: '568M',
        //   textProcess: '8K',
        //   series: 'BAAI',
        //   intro:
        //     'bge-reranker-v2-m3 是一个轻量级的多语言重排序模型。它基于 bge-m3 模型开发，具有强大的多语言能力，易于部署，并且推理速度快。该模型采用查询和文档作为输入，直接输出相似度分数，而不是嵌入向量。它适用于多语言场景，特别是在中文和英文处理方面表现出色。'
        // },
        {
          name: 'HunyuanVideo-HD',
          type: this.$t('aiModel.videoGeneration'),
          status: this.$t('aiModel.notInstalled'),
          spec: '13B',
          textProcess: '',
          series: 'tencent',
          intro: this.$t('aiModel.modelIntros.hunyuanVideoHD')
        }
      ]
    }
  },
  computed: {
    filteredModelList() {
      return this.modelList.filter(model => {
        const seriesMatch = this.selectedSeries === 'all' || model.series === this.selectedSeries
        const typeMatch = this.selectedType === 'all' || model.type === this.selectedType
        return seriesMatch && typeMatch
      })
    }
  },
  methods: {
    openDetail(model) {
      this.selectedModel = model
      this.showDetailModal = true
    },
    closeDetail() {
      this.showDetailModal = false
    },
    // 可以保留这个方法，但不再使用
    toggleDetail(index) {
      if (this.showDetailIndex === index) {
        this.showDetailIndex = -1
      } else {
        this.showDetailIndex = index
      }
    }
  }
}
</script>

<style scoped lang="less">
.modelContent {
  padding: 22px;
  .selectType {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    > span {
      font-weight: 400;
      font-size: 14px;
      color: #596777;
      padding-right: 39px;
    }
    > div {
      display: flex;
      font-weight: 400;
      span {
        font-size: 14px;
        color: #999999;
        margin-right: 39px;
        position: relative;
        cursor: pointer;
      }
      span.active {
        font-weight: 800;
        color: #ff6d00;
        // &::after {
        //   content: '';
        //   width: 23px;
        //   height: 4px;
        //   background: #ff6d00;
        //   border-radius: 3px;
        //   position: absolute;
        //   left: 50%;
        //   transform: translateX(-50%);
        //   bottom: -10px;
        // }
      }
    }
  }
  .content {
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
    .list {
      width: 18%;
      margin-right: 2.5%;
      margin-bottom: 20px;
      position: relative;
      background-color: #fff;
      border-radius: 8px;
      padding-bottom: 12px;
      // box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
      transition: all 0.3s;
      cursor: pointer;
      &:hover {
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        transform: translateY(-2px);
      }

      img {
        width: 100%;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
      }
      .title {
        height: 40px;
        line-height: 40px;
        font-weight: 700;
        font-size: 14px;
        color: #000000;
        padding: 0 15px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .tag {
        padding: 0 8px;
        height: 26px;
        border-radius: 4px;
        border: 1px solid rgba(77, 103, 137, 0.27);
        font-weight: 400;
        font-size: 11px;
        color: #4d6789;
        line-height: 24px;
        width: fit-content;
        margin-left: 15px;
      }
      .install {
        min-width: 55px;
        padding: 0 6px;
        height: 25px;
        background: rgba(255, 255, 255, 0.8);
        border-radius: 6px;
        text-align: center;
        line-height: 25px;
        position: absolute;
        top: 7px;
        right: 8px;
        font-weight: 400;
        font-size: 12px;
        color: #999999;
      }
      .not{
        color: #000000;
      }
      .model-info {
        padding: 10px 15px;
        margin-top: 10px;
        background-color: #f9f9f9;
        border-radius: 0 0 8px 8px;

        .info-item {
          margin-bottom: 8px;

          .label {
            font-weight: 700;
            color: #333;
          }

          .value {
            color: #666;
            font-size: 12px;
            line-height: 1.5;
          }
        }
      }
      .detail-btn {
        text-align: center;
        margin-top: 10px;
        color: #1890ff;
        font-size: 12px;
        cursor: pointer;
      }
    }
    .list:nth-child(5n) {
      margin-right: 0;
    }
  }
  .nodata {
    height: calc(100vh - 156px);
    display: flex;
    align-items: center;
    padding-bottom: 70px;
    flex-direction: column;
    justify-content: center;
    img {
      width: 285px;
      margin-bottom: 12px;
    }
    > div {
      width: 100%;
      display: flex;
      margin-top: -70px;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      .text {
        font-weight: 550;
        color: #0d2340;
        margin-bottom: 12px;
      }
    }
  }
  .detail {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    > div {
      width: 773px;
      padding: 31px 42px;
      background-image: url('~@/assets/img/model_detail.png');
      background-size: 100% 100%;
      .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 29px;
        .title {
          font-weight: 600;
          font-size: 18px;
          color: #000000;
          line-height: 29px;
          position: relative;
          &::after {
            content: '';
            width: 3px;
            height: 14px;
            background: #4d6bfe;
            position: absolute;
            bottom: 50%;
            transform: translateY(50%);
            left: -11px;
          }
        }
        .close {
          width: 14px;
          height: 14px;
          cursor: pointer;
        }
      }
      .tag {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        .list {
          display: flex;
          align-items: center;
          position: relative;
          margin-bottom: 29px;
          &::before {
            content: '';
            width: 1px;
            height: 19px;
            background: #e7e7e7;
            position: relative;
            left: -14px;
          }
          img {
            width: 21px;
            height: 21px;
            margin-right: 12px;
          }
          span {
            font-weight: 700;
            font-size: 14px;
            color: #000000;
          }
          span:last-child {
            font-weight: 400;
          }
        }
        .list:first-child {
          &::before {
            display: none;
          }
        }
      }
      .intro {
        display: flex;
        .title {
          min-width: 70px;
          height: 21px;
          font-weight: 700;
          font-size: 14px;
          color: #000000;
          padding-right: 6px;
        }
        > div:nth-child(2) {
          flex: 1;
          font-weight: 400;
          font-size: 14px;
          color: #000000;
        }
      }
    }
  }
}
</style>
